<div class="flex justify-between items-center pb-2 border-b border-gray-300">
  <span class="text-lg font-bold text-gray-900">{{
    'CONSTANT.RECOMMENDATION_SUBTYPE.' + intervention().subType | translate
  }}</span>
  <div class="flex items-baseline gap-1 text-gray-600">
    <i class="pi pi-calendar"></i>
    <span
      class="text-m font-normal"
      [aoDateWeekNumber]="intervention().nutrient?.targetDate"
    ></span>
  </div>
</div>
<div class="mt-2 pb-2 border-b border-gray-300">
  <div class="flex justify-between">
    <div class="font-semibold">
      {{ intervention().nutrient?.amount }} /
      {{ intervention().nutrient?.amountUnit | translateConstant: constantService.weightUnit }}
    </div>

    <div class="font-semibold">
      {{ intervention().nutrient?.area }} /
      {{ intervention().nutrient?.areaUnit | translateConstant: constantService.areaUnit }}
    </div>
  </div>
</div>
<!-- Nutrients Section -->
@for (type of ['macro', 'micro']; track type) {
  @if ((nutrients | nutrientsActivityType: type)?.length) {
    <div class="mt-1.5 pb-1.5">
      <div class="flex justify-between">
        <span class="font-medium">
          {{ 'INTERVENTION.NUTRIENTS.' + type.toUpperCase() + '_NUTRIENTS' | translate }}
        </span>
      </div>

      @for (nutrient of nutrients | nutrientsActivityType: type; track nutrient) {
        <div class="text-sm text-gray-500">{{ nutrient.nutrient.key }}: {{ nutrient.value }}%</div>
      }
    </div>
  }
}

@if (intervention().note?.length) {
  <div class="mt-1.5 text-sm">
    {{ intervention().note }}
  </div>
}
